import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

function Work() {
  const { t } = useLang();

  return (
    <section id="work" className="mt-20">
      <div className="section-label">
        <h2>{t.work.heading}</h2>
        <span className="section-aside">
          <Link to="/experience">{t.work.explore}</Link>
          <span>work.json</span>
        </span>
      </div>
      <ol className="study-list">
        {t.work.items.map((item) => (
          <li key={item.org} className="study-item">
            <span className="study-mark" aria-hidden="true" />
            <div>
              <p className="study-degree">{item.title}</p>
              <p className="study-org">{item.org}</p>
            </div>
            <div className="study-meta">
              <p>{item.when}</p>
              <p className="study-place">{item.place}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default Work;
